import type { Radian } from "#public"

// Type-preserving functions (return same branded type as input)
/** @pure */
export const Abs: <T extends number>(x: T) => T = Math.abs as never
/** @pure */
export const Ceil: <T extends number>(x: T) => T = Math.ceil as never
/** @pure */
export const Floor: <T extends number>(x: T) => T = Math.floor as never
/** @pure */
export const Fround: <T extends number>(x: T) => T = Math.fround as never
/** @pure */
export const Round: <T extends number>(x: T) => T = Math.round as never
/** @pure */
export const Trunc: <T extends number>(x: T) => T = Math.trunc as never

// Min/Max preserve type when all args are same type
/** @pure */
export const Max: <T extends number>(...values: T[]) => T = Math.max as never
/** @pure */
export const Min: <T extends number>(...values: T[]) => T = Math.min as never

// Trig functions (input Radian, output number)
/** @pure */
export const Cos: (x: Radian) => number = Math.cos
/** @pure */
export const Sin: (x: Radian) => number = Math.sin
/** @pure */
export const Tan: (x: Radian) => number = Math.tan

// Inverse trig (input number, output Radian)
/** @pure */
export const Acos: (x: number) => Radian = Math.acos as never
/** @pure */
export const Asin: (x: number) => Radian = Math.asin as never
/** @pure */
export const Atan: (x: number) => Radian = Math.atan as never
/** @pure */
export const Atan2: (y: number, x: number) => Radian = Math.atan2 as never

// Functions that always return plain number
/** @pure */
export const Exp: (x: number) => number = Math.exp
/** @pure */
export const Hypot: (...values: number[]) => number = Math.hypot
/** @pure */
export const Log: (x: number) => number = Math.log
/** @pure */
export const Log2: (x: number) => number = Math.log2
/** @pure */
export const Pow: (x: number, y: number) => number = Math.pow
export const Random: () => number = Math.random
/** @pure */
export const Sign: (x: number) => number = Math.sign
/** @pure */
export const Sqrt: (x: number) => number = Math.sqrt

// Constants
export const PI: Radian = Math.PI as Radian
export const E: number = Math.E

export const POS_INFINITY: number = Number.POSITIVE_INFINITY
export const NEG_INFINITY: number = Number.NEGATIVE_INFINITY
export const MAX_INTEGER: number = Number.MAX_SAFE_INTEGER
export const MIN_INTEGER: number = Number.MIN_SAFE_INTEGER
export const MAX_REAL: number = Number.MAX_VALUE
export const MIN_REAL: number = Number.MIN_VALUE

// conversion
/** @pure */
export const ToNumber: (value: string | number | bigint | boolean) => number = Number

// checks
/** @pure */
export const InfinityQ = (x: number): boolean => !Number.isFinite(x)
/** @pure */
export const IntegerQ: (x: number) => boolean = Number.isInteger
/** @pure */
export const NanQ: (x: number) => boolean = Number.isNaN
